export type TransitionType = 'tab' | 'push' | 'expand';

const TAB_ROUTES = new Set([
  '/',
  '/search',
  '/crew',
  '/crew/find',
  '/crew/hidden',
  '/profile',
  '/trending',
]);

export function getTransitionType(pathname: string): TransitionType {
  if (TAB_ROUTES.has(pathname)) return 'tab';
  if (pathname.startsWith('/stories/')) return 'expand';
  return 'push';
}
